import { CatalogAccessType } from "@bvhi/backend-api";
import { Chip } from "@bvhi/ui-base";
import { useTranslation } from "react-i18next";

interface Props {
  status: string;
  size?: "small" | "medium";
}

export function PlatformCatalogAccessTypeChip({ status, size = "small" }: Props) {
  const { t } = useTranslation(["enums"]);

  let label = "";
  switch (status) {
    case CatalogAccessType.ALL_CUSTOMERS:
      label = t("enums:enums.catalog.access.type.all.customers");
      break;
    case CatalogAccessType.PROTECTED:
      label = t("enums:enums.catalog.access.type.protected");
      break;
    case CatalogAccessType.PUBLIC:
      label = t("enums:enums.catalog.access.type.public");
      break;
  }

  return <Chip label={label} size={size} />;
}
